import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useToast } from '@/hooks/use-toast';

interface Notification {
  id: number;
  title: string;
  message: string;
  time: string;
  unread: boolean;
}

interface NotificationsPopoverProps {
  className?: string;
}

export const NotificationsPopover: React.FC<NotificationsPopoverProps> = ({ className }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const { toast } = useToast();

  // Mock notifications data
  const notifications: Notification[] = [
    { id: 1, title: 'New transaction processed', message: 'CHF 5,240.00 added', time: '5m ago', unread: true },
    { id: 2, title: 'Validation required', message: '12 transactions pending', time: '1h ago', unread: true },
    { id: 3, title: 'Report generated', message: 'Q1 Financial Report', time: '2h ago', unread: false },
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <Popover open={showNotifications} onOpenChange={setShowNotifications}>
      <PopoverTrigger asChild>
        <button 
          className={`w-[38px] h-[38px] relative bg-brand-secondary rounded-full flex items-center justify-center hover:bg-brand-accent/10 transition-colors ${className}`}
          aria-label="Notifications"
        >
          <i className="fa-solid fa-bell text-brand-primary text-sm"></i>
          {unreadCount > 0 && (
            <div className="absolute top-1 right-1 w-2 h-2 bg-brand-danger rounded-full border-2 border-brand-secondary"></div>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-semibold">Notifications</h3>
          <Badge variant="secondary">{unreadCount} new</Badge>
        </div>
        <ScrollArea className="h-80">
          {notifications.map((notif) => (
            <div
              key={notif.id}
              className={`p-4 border-b hover:bg-accent cursor-pointer transition-colors ${
                notif.unread ? 'bg-accent/50' : ''
              }`}
              onClick={() => {
                toast({
                  title: notif.title,
                  description: notif.message,
                });
                setShowNotifications(false);
              }}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium">{notif.title}</p>
                  <p className="text-sm text-muted-foreground">{notif.message}</p>
                  <span className="text-xs text-muted-foreground">{notif.time}</span>
                </div>
                {notif.unread && (
                  <div className="w-2 h-2 rounded-full bg-brand-primary mt-2"></div>
                )}
              </div>
            </div>
          ))}
        </ScrollArea>
        <div className="p-2 border-t">
          <Button variant="ghost" className="w-full" size="sm">
            Mark all as read
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};







